

export const interestsVariableArray = [0.2, 1.1]